import React, {
  useState,
  useContext,
  createContext,
  useEffect,
  useCallback
} from "react";
import { useAuth } from "./useAuth";
import { CartServices } from "../services/CartServices";
import { useClientCity } from "./useClientCity";

const cartContext = createContext();

export function ProvideCart({ children }) {
  const cart = useProviderCart();
  return <cartContext.Provider value={cart}>{children}</cartContext.Provider>;
}

export const useCart = () => {
  return useContext(cartContext);
};

// Provider hook that creates Cart object and handles state
function useProviderCart() {
  // ** Hooks
  const { userSecure } = useAuth();
  const { clientCity } = useClientCity();
  /**
   *  State
   */
  const [cart, setCart] = useState({ items: [], data: [] });

  /**
   * add new item to cart
   * @param {Symbol} data
   */
  const addToCart = (data) => {
    return new Promise((resolve, reject) => {
      CartServices.addMealTocart({ data: data, token: userSecure.access_token })
        .then((res) => {
          const { data } = res;
          if ("cart_meal" in data) {
            getCart();
            resolve({ added: true });
          } else {
            reject({ error: "error" });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  /**
   * Delete item from cart
   * @param {Number} mealID
   */
  const removeFromCart = (mealID) => {
    return new Promise((resolve, reject) => {
      CartServices.cartDelete({ mealID: mealID })
        .then(async (response) => {
          await getCart();
          resolve({isDelete:true})
        })
        .catch((error) => {
          reject(error)
        });
    });
  };

  /**
   * ## update
   * @param {number} cartID
   * @param {FormDate} formData
   */
  const updateCartQuantity = (cartID, formData) => {
    return new Promise((resolve, reject) => {
      CartServices.cartUpdate({
        token: userSecure.access_token,
        cartID: cartID,
        formData: formData
      })
        .then((result) => {
          const { data } = result;
          if ("cart_meal" in data) {
            getCart();
            resolve({ updateed: true });
          } else {
            reject({ updateed: false });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  /**
   * apply Coupon ToCart
   */
  const applyCouponToCart = (coupon_code) => {};

  /**
   * remove Coupon From Cart
   */
  const removeCouponFromCart = () => {};

  // ** get Cart
  // const getCart = useCallback(() => {
  //   if (Object.keys(clientCity).length > 0) {
  //     CartServices.getCart()
  //       .then((res) => {
  //         const { data } = res;
  //         console.log('data', data)
  //         const items = [];
  //         if(Array.isArray(data)){
  //           if (data.length > 0) {
  //             data.map((item) => items.push(...item?.meal));
  //           }
  //           setCart({ items: [...items], data: [...data] });
  //         }
  //         //setCart({ ...data });
  //       })
  //       .catch((error) => {
  //         console.log("error", error);
  //       });
  //   }
  // }, [clientCity]);

  // useEffect(() => {
  //   if (Object.keys(clientCity).length > 0) {
  //     if (clientCity.id !== 0) {
  //       getCart();
  //     }
  //   }

  //   return () => {};
  // }, [clientCity, getCart]);
  const getCart = () => {
    if (clientCity && Object.keys(clientCity).length > 0) {
      CartServices.getCart()
        .then((res) => {
          const { data } = res;
          const items = [];
          if (Array.isArray(data)) {
            if (data.length > 0) {
              data.map((item) => items.push(...item?.meal));
            }
            setCart({ items: [...items], data: [...data] });
          }
          //setCart({ ...data });
        })
        .catch((error) => {
          console.log("error");
        });
    }
  };
  useEffect(() => {
    if (clientCity && Object.keys(clientCity).length > 0) {
      if (clientCity.id !== 0) {
        getCart();
      }
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientCity]);

  return {
    cart,
    getCart,
    removeFromCart,
    updateCartQuantity,
    addToCart,
    applyCouponToCart,
    removeCouponFromCart
  };
}
